<template>
    <app-layout>
        <template #header>
            <div class="flex flex-row justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    <em class="fas fa-credit-card"></em> Cartão
                </h2>
                <balance :short="true" />
            </div>
        </template>
        <div class="py-12 pt-20 pb-6">
            <flash :timeout="5000" />
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg py-4 h-screen flex flex-col items-center justify-center">
                    <div class="mt-9 mb-20">
                        <div class="flex flex-col justify-center gap-5">
                            <div class="self-center font-extrabold text-2xl text-black text-opacity-70  max-w-max border-b-2 border-yellow-400">
                               Parabéns
                            </div>
                            <div class="text-black text-opacity-60 text-base">
                                Seu pedido já está sendo processado e logo logo seu cartão estará em suas mãos, fique atento no status
                                <br>
                                 da sua solicitação, assim que seu cartão chegar, é só confirmar a entrega pela própria solicitação.
                            </div>

                                <div class="self-stretch mt-4">
                                    <img
                                        class="mx-auto"
                                        src="images/Congratulations.svg"
                                        width="300"
                                    />
                                 </div>
                            <div class="flex justify-center mt-5">
                                <button
                                    style="background-color: #EFB207;"
                                    class="px-5 py-2 gap-2 rounded-md uppercase text-black text-opacity-70 text-xs font-medium"
                                    @click="goListRequest"
                                >
                                    Concluir
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from "./../../Layouts/AppLayout";
import Welcome from "./../../Jetstream/Welcome";
import ptBR from "vuejs-datepicker/dist/locale";
import Button from "../../Jetstream/Button";
import Balance from "../../Helpers/Balance";
import Flash from "../../Helpers/Flash";

export default {
    components: {
        Flash,
        Balance,
        Button,
        AppLayout,
        Welcome
    },
    data() {
        return {
            ptBR: ptBR
        };
    },
    methods: {
        goListRequest() {
            this.$inertia.get(this.route("card.requests-list"));
        },
    }
};
</script>
